









import { Action, Getter, Mutation } from 'vuex-class'
import { Vue, Component } from 'vue-property-decorator'
import Account from '@/api/models/Account'
import Connection from '@/api/models/Connection'
import { isEmptyString } from '@/components/helper'
import { RootStateMutations } from '@/store/mutations'
import Layout from '@/shared/views/Layout.vue'

@Component({
    components: {
        Layout
    }
})
export default class BaseLayout extends Vue {
    @Action('loadConnection')
    protected loadConnectionAction: () => Promise<void>

    @Mutation(RootStateMutations.setLoading)
    protected setLoading: (state: boolean) => void

    @Getter('currentConnection')
    protected currentConnection!: Connection

    @Getter('currentAccount')
    readonly currentAccount: Account

    async created (): Promise<void> {
        await this.loadData()
    }

    async loadData(): Promise<void> {
        if (this.needLoadConnection()) {
            this.setLoading(true)
            try {
                await this.loadConnectionAction()
            } catch (err) {
                await this.$router.push({ name: 'connect' })
                return
            } finally {
                this.setLoading(false)
            }
        }

        if (this.needAccountInstall()) {
            await this.$router.push({ name: 'account_install' })
        }
    }

    needAccountInstall(): boolean {
        const accounts = this.currentConnection.accounts
        const accountClientId = this.currentAccount?.cdekClientId ?? ''
        const accountClientSecret = this.currentAccount?.cdekClientSecret ?? ''
        const currentRoute = this.$router.currentRoute.name

        return (!(accounts.length > 0) && currentRoute !== 'account_install') ||
            (currentRoute === 'account_settings' && isEmptyString(accountClientId) && isEmptyString(accountClientSecret))
    }

    needLoadConnection(): boolean {
        return isEmptyString(this.currentConnection.crmUrl) && isEmptyString(this.currentConnection.crmToken)
    }
}
